const actions = {
  REQUESTING: 'DraftInventorys/REQUESTING',
  RESPONSE_ERROR: 'DraftInventorys/RESPONSE_ERROR',

  FETCH_DRAFTINVENTORYS: 'DraftInventorys/FETCH',
  LIST_DRAFTINVENTORY: 'DraftInventory/LIST',

  FETCH_DRAFTINVENTORY: 'DraftInventory/FETCH',
  NEW_DRAFTINVENTORY: 'DraftInventory/NEW',
  EDIT_DRAFTINVENTORY: 'DraftInventory/EDIT',
  RESET_DRAFTINVENTORY: 'DraftInventory/RESET',

  RE_FETCH_DRAFTINVENTORYS: 'DraftInventorys/REFRESH',
  SAVE_DRAFTINVENTORY: 'DraftInventory/SAVE',
  SAVING_DRAFTINVENTORY: 'DraftInventory/SAVING',
  SAVE_DRAFTINVENTORY_RECIEVED: 'DraftInventory/SAVE_DRAFTINVENTORY_RECIEVED',

  DELETE_DRAFTINVENTORY: 'DraftInventory/DELETE',
  DELETE_DRAFTINVENTORY_RECIEVED: 'DraftInventory/DELETE_RECIEVED',

  TRANSFERTOINVENTORY: 'DraftInventory/TRANSFER_TO_INVENTORY',
  TRANSFERTOINVENTORY_RECIEVED: 'DraftInventory/TRANSFER_TO_INVENTORY_RECIEVED',
}

export default actions
